module.exports = __webpack_public_path__ + "static/media/message-preview.2585481c.svg";